import { useCallback, useEffect } from 'react';
import type { LinterContext } from '@scale/genai-compass-shared/cards/linter';
import { ReviewLevel } from '@scale/shared/defaults';
import { useCompassCard } from '@scale/compass-ui/store';
import { useProjectId } from 'react-scale/corp/views/CorpProjectGroupManager/hooks/useProjectId';
import _ from 'lodash';

const useLinterCard = (index: number) => {
  const { card, updateCardContext } = useCompassCard(index);
  const context = card.defaultContext as LinterContext;
  const projectId: string | undefined = useProjectId();

  const setProjectId = useCallback(
    (projectId: string) => {
      const updatedContext: LinterContext = { ...context, projectId };
      updateCardContext(updatedContext);
    },
    [context, updateCardContext],
  );

  const setLinterNames = useCallback(
    (linterNames: string[]) => {
      const updatedContext: LinterContext = { ...context, linterNames };
      updateCardContext(updatedContext);
    },
    [context, updateCardContext],
  );

  const setReviewLevel = useCallback(
    (reviewLevel: ReviewLevel | undefined) => {
      const updatedContext: LinterContext = { ...context, reviewLevel };
      updateCardContext(updatedContext);
    },
    [context, updateCardContext],
  );

  // // Memoize the canSubmit value to prevent unnecessary updates
  // const canSubmit = Boolean(data.length > 0 && context?.linterNames?.length > 0);

  // useEffect(() => {
  //   // Only update if the current canSubmit state is different from what we want
  //   if (card.canSubmit !== canSubmit) {
  //     updateCardCanSubmit(canSubmit);
  //   }
  // }, [canSubmit, card.canSubmit, updateCardCanSubmit]);

  useEffect(() => {
    if (!_.isEmpty(projectId) && context.projectId !== projectId) {
      const updatedContext: LinterContext = { ...context, projectId };
      updateCardContext(updatedContext);
    }
  }, [context, projectId, updateCardContext]);

  return {
    linterNames: context.linterNames,
    setLinterNames,
    reviewLevel: context.reviewLevel as ReviewLevel | undefined,
    setReviewLevel,
    projectId: context.projectId,
    setProjectId,
    allowEditProjectId: _.isEmpty(projectId),
  };
};

export default useLinterCard;
